module.exports = __webpack_public_path__ + "static/media/location.80609515.jpg";